import mixitup from 'mixitup';

class MixitupFilter {
    constructor(wrapper) {
        this.mixer = null;
        this.itemContainer = wrapper.querySelector('.filter');
        this.filterButtons = wrapper.querySelectorAll('.filter-button');
        this.filterSelect = wrapper.querySelector('.custom-select');

        let intViewportWidth = window.innerWidth;

        if (intViewportWidth <= 768) {

            this.filterSelect.addEventListener('change', e => {
                const filterAttr = e.target.value;
                location.hash = 'filter=' + encodeURIComponent(filterAttr);
                e.preventDefault();
            });

        } else {

            this.filterButtons.forEach(button => {
                button.addEventListener('click', e => {
                    const filterAttr = e.target.getAttribute('data-filter');
                    location.hash = 'filter=' + encodeURIComponent(filterAttr);
                    e.preventDefault();
                });

            });
        }

        window.addEventListener('hashchange', this.onHashChange.bind(this));

        this.onHashChange();
    }

    getHashFilter() {
        const hash = location.hash;
        const matches = location.hash.match(/filter=([^&]+)/i);
        const hashFilter = matches && matches[1];

        return hashFilter && decodeURIComponent(hashFilter);
    }

    onHashChange() {
        const filterParam = this.getHashFilter();
        const filterString = filterParam ? filterParam : "all";

        if (!this.mixer) {
            this.mixer = mixitup(this.itemContainer, {
                load: {
                    filter: filterString,
                },
                animation: {
                    duration: 300,
                    effects: "fade",
                },
            });
        } else {
            this.mixer.filter(filterString);
        }
    }
}

export default class Filter {
	static init(){
		document.addEventListener('bless', () => {
            const filterWrapper = document.querySelectorAll('.mixitup-wrapper');

            if (!filterWrapper) {
                return;
            }

            filterWrapper.forEach(filter => {
                new MixitupFilter(filter);
            });

		});
	}
}
